
import { Component, Mixins, Prop } from "vue-property-decorator";
import { FormatStructureEditorStorePresenter } from "../../../../domain/editableFormat";

@Component
export default class FormatStructureEditorStoreReferableMixin extends Mixins() {
  @Prop()
  storePresenter: FormatStructureEditorStorePresenter;
}
